import { ofType } from "redux-observable";
import { debounceTime, of, switchMap, map, distinctUntilChanged } from "rxjs";
import routingStateSlice from "./slices";
import { buildNewUrl } from '../services/urlBuilder'
import { urlComponentsSelector } from "./selectors";

const actions = routingStateSlice.actions;
const updateUrlEpic = (action$, state$) =>
  action$.pipe(
    ofType(
      actions.updatePagination,
      actions.updateSubdirectory,
      actions.updateLocation,
      actions.updateQueryString,
      actions.updateBuilderName,
    ),
    map(() => {
      const config = urlComponentsSelector(state$.value);
      const newUrl = buildNewUrl(config);
      return newUrl.href;
    }),
    distinctUntilChanged(),
    debounceTime(100),
    switchMap((url) => of(actions.updateUrl(url)))
  );

export default updateUrlEpic;